import { fetchJWT } from '../api/tokenApi';
import { fetchJWSToken } from '../api/cardsTokenApi';
import { APP_ID_CREDIT_CARD_APP, APP_ID_ONE_REDI } from '../util/Constants';
import { getAppName, getBotName } from '../util/parameterParser';

export const connectors = () => {
  window.addEventListener('lcw:onMessageReceived', function handleWidgetMessageReceivedEvent(
    payload
  ) {
    postToNativeApp(payload);
  });

  var lcwReady = false;
  var startChatFired = false;

  window.addEventListener('lcw:ready', function handleLivechatReadyEvent(payload) {
    lcwReady = true;
    setTimeout(() => {
      if (lcwReady && !startChatFired) {
        Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
      }
    }, 100);
  });

  window.addEventListener('lcw:startChat', function handleLivechatStartedEvent() {
    startChatFired = true;
  });

  window.addEventListener('lcw:error', function handleErrorEvent(errorEvent) {
    window.dtrum?.reportError(
      `App name: ${getAppName(window.urlParams.appId)}, Chatbot name: ${getBotName(
        window.urlParams.appId
      )}, Error Code: ${errorEvent.detail.errorCode} and Error description: ${JSON.stringify(
        errorEvent.detail.errorDescription
      )}`
    );
  });
};

export const postToNativeApp = (payload) => {
  if (window.AndroidInterface) {
    window.AndroidInterface.onMessageReceived(JSON.stringify(payload.detail));
  } else if (window.webkit) {
    window.webkit.messageHandlers.onMessageReceived.postMessage(JSON.stringify(payload.detail));
  } else {
    console.log(`No mobile interface detected`);
  }
};

export const setAuthTokenForPVA = () => {
  var auth = {};
  if (
    window.urlParams.appId === APP_ID_CREDIT_CARD_APP ||
    window.urlParams.appId === APP_ID_ONE_REDI
  ) {
    auth.getAuthenticationToken = async (callback) => {
      try {
        const response = await fetchJWSToken();
        callback(response);
      } catch (error) {
        callback(null);
      }
    };
  } else {
    auth.getAuthenticationToken = async (callback) => {
      try {
        const response = await fetchJWT();
        callback(response);
      } catch (error) {
        callback(null);
      }
    };
  }
  window.auth = auth;
};
